<template>
  <div>
    <div class="pa-4 d-flex justify-space-between align-start">
      <div>
        <Breadcrumbs headline="Phân công quản lý kho" :link="[{ text: 'Phân công quản lý kho', href: '/inventory-management' }]" />
      </div>
    </div>
    <v-card class="mx-4 mb-6 elevation-0">
      <SettingTable />
    </v-card>
    <popupEditUserInventory ref="new-inventory-management" />
  </div>
</template>
<script>
import Breadcrumbs from '@/components/layout/Breadcrumbs'
import SettingTable from '../../modules/inventory-management/SettingTable.vue'
export default {
  components: {
    Breadcrumbs,
    SettingTable
  },
  methods: {
    onAdd() {
      this.$refs['new-inventory-management'].onClear()
      this.$refs['new-inventory-management'].openDialog()
    }
  }
}
</script>
